module.exports = __webpack_public_path__ + "img/layout_vertical_icon.471604ef.svg";